// extracted by mini-css-extract-plugin
export default {"container":"BaseWizard_container__DJ6gH"};